import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from './LangContext';

/** A drop-in replacement for `react-router-dom` Link that automatically
 *  prefixes internal paths with the current language code (except Italian).
 *  Pass external URLs (http://...) as-is. */
export const L = React.forwardRef(function L({ to, ...rest }, ref) {
  const { withLang } = useLang();
  const isExternal = typeof to === 'string' && /^(https?:|mailto:|tel:|#)/.test(to);
  const target = isExternal ? to : withLang(to || '/');
  return <Link ref={ref} to={target} {...rest} />;
});
